import questions from "../../assets/js/helpMultilngual/bs_it_questions";
import troubles from "../../assets/js/helpMultilngual/bs_en_troubles";
const it = {
  language: "Italia",
  helpCenter: {
    documentTitle: "Centro assistenza",
    title: [
      "Collegare e attivare il veicolo",
      "Problemi con l'account",
      "Guida",
      "ADAS",
      "Informazioni e intrattenimento",
      "Guida all'uso delle app",
      "Aggiornamento del veicolo",
      "Sicurezza della batteria",
      "Manutenzione",
      "Autoverifica degli errori"
    ],
    description: "Description:",
    solution: "Suggested Solution:",
    exAssistance: "Assistenza Sostituzione Batteria",
    exAssistanceList: [
      "Informazioni sul Servizio di Sostituzione Batteria Intelligente BlueShark",
      "Informazioni sull'Account di Sostituzione Batteria",
      "Informazioni sui Piani di Sostituzione Batteria",
      "Informazioni sull'utilizzo del servizio di sostituzione batteria"
    ],
    exAssistanceSubtitle: [
      [
        "Informazioni sul Servizio di Sostituzione Batteria Intelligente BlueShark"
      ],
      [
        "Come Ottenere un Account di Sostituzione Batteria?",
        "Quali sono gli utilizzi di un account di sostituzione delle batterie?"
      ],
      [
        "Cos'è un Piano di Sostituzione Batteria?",
        "È possibile trasferire e utilizzare nel mese successivo la quota rimanente di questo mese?",
        "È possibile ottenere un rimborso per il piano di sostituzione batteria acquistato?",
        "È possibile rinnovare il piano di sostituzione batteria acquistato?",
        "Quali sono le regole per la data di efficacia del piano di sostituzione batteria?"
      ],
      [
        "Dopo l'acquisto del piano, come effettuo la prima sostituzione della batteria?",
        "Come effettuare una sostituzione della batteria?",
        "Come posso verificare le informazioni sulla batteria presso diverse stazioni di cambio batteria?",
        "Quali potrebbero essere le ragioni di un cambio di batteria fallito?"
      ]
    ],
    exAssistanceInfo: [
      [
        [
          "Il servizio di sostituzione batterie intelligente di Blueshark è un rapido servizio di rifornimento energetico fornito da Blueshark per mercati specifici. Questo include l'installazione di stazioni di sostituzione batterie, l'offerta di servizi di leasing delle batterie e funzionalità di scambio. Affronta efficacemente l'inconveniente della scarsa autonomia nelle motociclette elettriche e può realizzare il rifornimento e la sostituzione delle batterie in appena 3 secondi.",
          "A causa delle diverse situazioni di domanda nei diversi mercati, il servizio di sostituzione batterie intelligente di Blueshark non copre completamente tutte le regioni di vendita dei veicoli Blueshark. In alcune aree di vendita, non vengono forniti servizi pertinenti di sostituzione e rifornimento batterie. Per dettagli specifici, si prega di consultare i punti vendita locali o i concessionari."
        ]
      ],
      [
        [
          "Se il servizio di sostituzione batterie intelligente di Blueshark è disponibile nella tua zona, dovrai prima scaricare l'app di Blueshark e registrare con successo un account nell'app. Nella homepage dell'app, troverai la scheda della funzione 'Servizio di Sostituzione Batterie'.",
          "Seleziona la scheda della funzione 'Servizio di Sostituzione Batterie', scegli un operatore adatto per la sostituzione delle batterie, leggi e accetta l''Accordo di Servizio di Sostituzione Batterie', e sarai in grado di creare il tuo account di sostituzione.",
          "Se il servizio di sostituzione batterie intelligente di Blueshark non è ancora disponibile nella tua zona, non potrai accedere alla scheda della funzione 'Servizio di Sostituzione Batterie' e non sarai in grado di creare un account per la sostituzione delle batterie."
        ],
        [
          "L'account di sostituzione delle batterie è l'unico account di identità utilizzato per accedere al servizio di sostituzione batterie intelligente di Blueshark. Senza un account di sostituzione batterie, non sarai in grado di usufruire dei vantaggi del servizio di sostituzione batterie. L'account di sostituzione batterie può essere utilizzato per l'acquisto di pacchetti di sostituzione, l'utilizzo del servizio di sostituzione, la gestione dei limiti e degli asset di sostituzione, e per tenere traccia dei record di sostituzione e del consumo."
        ]
      ],
      [
        [
          "I piani di sostituzione delle batterie sono beni elettronici virtuali di vantaggi creati da vari operatori di sostituzione batterie che offrono servizi, in base alle specifiche esigenze delle attività di sostituzione nelle diverse regioni.",
          "Attualmente, le regole dei piani supportano tre metodi di fatturazione: addebito in base al consumo di elettricità, addebito in base al numero di sostituzioni batterie e quote di sostituzione batterie illimitate. Le quote vengono allocate mensilmente e la fatturazione può essere effettuata mensilmente, trimestralmente o annualmente. I piani specifici disponibili dipendono dalle regole effettive stabilite dall'operatore scelto.",
          "All'acquisto di un piano di sostituzione delle batterie, è possibile usufruire dei vantaggi dei servizi di sostituzione delle batterie. È possibile visitare negozi fisici o rivenditori per richiedere i vantaggi del servizio di sostituzione delle batterie e poi utilizzare il servizio di sostituzione."
        ],
        [
          "Seguendo le attuali regole del servizio di sostituzione batteria, ogni quota non utilizzata per il mese corrente verrà azzerata all'ingresso nel ciclo di fatturazione del mese successivo e non si accumulerà nel mese successivo. Si prega di scegliere un piano di sostituzione batteria che si adatti alle reali esigenze di consumo di elettricità per l'uso quotidiano."
        ],
        [
          "I piani di sostituzione batteria sono vantaggi virtuali sotto forma di beni elettronici e, secondo le regole di utilizzo della sostituzione batteria, i rimborsi non sono possibili. Raccomandiamo di valutare attentamente il tuo acquisto per evitare eventuali perdite. Grazie per la comprensione."
        ],
        [
          "Quando acquisti un piano di sostituzione batteria, presti attenzione alle regole di rinnovo del piano. Finché soddisfi i criteri di rinnovo, è possibile rinnovare il piano. Dopo il rinnovo, i vantaggi della sostituzione batteria continueranno ad accumularsi nella pagina 'I Miei Cambi'. Si prega di pianificare e rinnovare in base alle tue effettive esigenze."
        ],
        [
          "Dopo l'acquisto di un piano di sostituzione batterie, questo diventerà effettivo il primo giorno del mese successivo. Si prega di notare che se hai bisogno di effetto immediato, dovresti selezionare l'opzione 'Applica immediatamente nel mese corrente' e assicurarti che la quota del piano per il mese corrente sia sufficiente. Questo permetterà al piano di sostituzione batterie di diventare effettivo immediatamente. Quando acquisti un piano di sostituzione batterie, pianifica in modo ragionevole il tempo di attivazione dei piani in base alle tue esigenze personali."
        ]
      ],
      [
        [
          "Dopo l'acquisto del piano di sostituzione batterie, il primo passo è seguire le istruzioni dell'app e recarsi in un negozio fisico o presso un rivenditore per ottenere i vantaggi del servizio di sostituzione batterie e registrare la batteria. Se la batteria è in leasing, dovrai recarti in un negozio fisico o presso un rivenditore per noleggiare la batteria e pagare il deposito del noleggio della batteria.",
          "Una volta registrata, la batteria è idonea per i vantaggi del servizio di sostituzione batterie. Puoi inserire la batteria nella stazione di sostituzione batterie e la stazione erogherà automaticamente una batteria completamente carica o ad alta capacità, legando i vantaggi del servizio di sostituzione batterie alla batteria appena erogata."
        ],
        [
          "Dopo che l'utente completa la registrazione iniziale della batteria per il primo scambio, per ogni successivo scambio di batteria, basta inserire una batteria poco carica in uno degli slot vuoti nella stazione di sostituzione batterie, e la stazione erogherà automaticamente una batteria completamente carica o ad alta capacità.",
          "Se la stazione di sostituzione batterie non eroga la batteria come previsto, segui le istruzioni visualizzate sullo schermo della stazione e contatta il servizio clienti per assistenza."
        ],
        [
          "Puoi selezionare il servizio di sostituzione batterie nell'app di Blueshark, andare alla pagina principale della mappa di sostituzione batterie e trovare informazioni sulle stazioni di sostituzione batterie nelle vicinanze. Queste informazioni includono il nome della stazione, la posizione, la distanza da te e una panoramica dello stato della batteria. Cliccando su una stazione di sostituzione batterie specifica, potrai accedere alla sua pagina di informazioni dettagliate e visualizzare le informazioni sulla batteria per quella stazione selezionata."
        ],
        [
          "Ci sono diverse possibili ragioni per un fallimento nella sostituzione delle batterie:",
          "① La batteria inserita ha un servizio di sostituzione batterie scaduto, il che impedisce una sostituzione riuscita. Dovresti rinnovare il servizio prima di utilizzarlo.",
          "② La stazione di sostituzione batterie non ha batterie disponibili per la sostituzione, il che significa che le batterie all'interno della stazione non soddisfano le condizioni di sostituzione. In questo caso, puoi provare un'altra stazione per la sostituzione.",
          "③ Se nessuna delle situazioni sopra citate si applica e continui a sperimentare fallimenti ripetuti nella sostituzione delle batterie, ti preghiamo di contattare l'assistenza clienti per assistenza."
        ]
      ]
    ],
    quickGuide: "Guida rapida all'uso del veicolo",
    quickGuideList: [
      "Operazioni di base",
      "Attivazione del veicolo",
      "Funzione di parcheggio",
      "Funzione di guida",
      "Guida e modalità"
    ],
    QuickListSubtitle: [
      ["Operazioni di base per H1 2023", "Operazione di base di R1 2023"],
      ["Attivazione del veicolo H1 2023", "Attivazione del veicolo R1 2023"],
      ["H1 2023 Funzione di parcheggio", "R1 2023 Funzione di parcheggio"],
      ["H1 2023 Funzione di guida", "R1 2023 Funzione di guida"],
      ["H1 2023 Guida e modalità", "R1 2023 Guida e modalità"]
    ],
    h1Node:
      "Nota: questa guida si applica solo a H1 2023. Per H1 lite, fare riferimento al manuale di istruzioni. Questa guida è solo per un uso rapido. Per le operazioni dettagliate, consultare il manuale di istruzioni.",
    r1Node:
      "Nota: questa guida si applica solo a R1 2023. Per R1 lite, fare riferimento al manuale di istruzioni. Questa guida è solo per un uso rapido. Per le operazioni dettagliate, consultare il manuale di istruzioni.",
    lightDescription: "Spiegazione delle luci di segnalazione",
    signalLeft: "Freccia sinistra",
    signalRight: "Freccia destra",
    highBeam: "Fari abbaglianti",
    lowBeam: "Fari anabbaglianti",
    lowPowerLight: "Spia di avviso batteria scarica",
    faultLight: "Spia di avviso guasto",
    readyLight: "Spia di stato pronto",
    instrumentPic: "Diagramma del cruscotto",
    leftKeyDescription: "Istruzioni del pulsante (manubrio sinistro)",
    leftHandPic: "Diagramma del manubrio sinistro",
    rightKeyDescription: "Istruzioni del pulsante (manubrio destro)",
    rightHandPic: "Schematismo del manubrio destro",
    overtakingLightKey:
      "Interruttore del segnale di sorpasso: attivare il segnale per lampeggiare",
    lowBeanKey:
      "Interruttore della luce di posizione: alternare per accendere la luce di posizione",
    highBeamKey:
      "Interruttore della luce abbagliante: alternare per accendere la luce abbagliante",
    configKey:
      "Tasto di conferma: Utilizzato per operazioni di conferma nella smart card",
    smartKey:
      "Chiave intelligente: Utilizzata per cambiare e controllare nella smart card",
    LeftTrunSignalKey:
      "Leva degli indicatori di direzione: spostare a sinistra per attivare l'indicatore di direzione sinistro, premere al centro per spegnere l'indicatore di direzione",
    RightTrunSignalKey:
      "Leva degli indicatori di direzione: spostare a destra per attivare l'indicatore di direzione destro, premere al centro per spegnere l'indicatore di direzione",
    hornKey:
      "Pulsante del clacson: tenere premuto con la mano per suonare il clacson, rilasciare per interrompere il suono del clacson",
    cruiseControlKey:
      "Pulsante del controllo della velocità di crociera: premere brevemente per attivare il controllo della velocità di crociera (quando la velocità del veicolo è superiore a 15 km/h), premere brevemente di nuovo o frenare per disattivare il controllo della velocità di crociera",
    waringKey:
      "Pulsante lampeggianti di pericolo: premere per attivare le luci di emergenza in caso di malfunzionamento del veicolo o situazione di emergenza.",
    costomKey: "Tasto personalizzato: in attesa di aggiornamento",
    turboKey:
      "Tasto TURBO: breve pressione per entrare in modalità TURBO, breve pressione di nuovo per uscire",
    sportKey:
      "Tasto SPORT: breve pressione per entrare in modalità SPORT, breve pressione di nuovo per uscire",
    openSeatKey:
      "Tasto secchio sedile: breve pressione per aprire il secchio sedile quando il veicolo è acceso",
    transferAssistanceKey:
      "Tasto di assistenza al movimento: quando il veicolo è in stato di guida e fermo, premere il tasto MAM per entrare in modalità di assistenza al movimento. In questo momento, è possibile muovere il veicolo lentamente avanti e indietro girando la 'M' o il manubrio.",
    gearKey: "Pulsante modalità: premere brevemente per cambiare modalità",
    LeftGearKey: "Tasto di cambiamento: cambio verso sinistra per scalare giù",
    RightGearKey: "Tasto di cambiamento: cambio verso destra per scalare su",
    volumeIncreaseKey:
      "Tasto di controllo del volume: premere brevemente il pulsante destro per aumentare il volume",
    volumedecreaseKey:
      "Tasto di controllo del volume: breve pressione del tasto sinistro per diminuire il volume",
    readyKey:
      "Tasto Ready: premere brevemente per passare dalla modalità di guida alla modalità di parcheggio",
    activationNode:
      "Nota: Il veicolo è in uno stato inattivo al momento della consegna e deve essere attivato per utilizzare tutte le funzionalità e i servizi.",
    activeCardPic: "Illustrazione della carta di attivazione del veicolo",
    activeUIPic: "Illustrazione dell'interfaccia di attivazione del veicolo",
    activeStep1: "Passaggio 1: Prima pagina di avvio",
    activeStep2: "Passaggio 2: Pagina guida per il download dell'app",
    activeStep3: "Passaggio 3: Guida alla pagina di attivazione",
    activeStep4: "Passaggio 4: Pagina dei risultati di attivazione",
    activeStepInfo1: "Quando questa scheda appare sul veicolo, premere",
    activeStepInfo2: "brevemente per accedere al processo di attivazione",
    activeStepInfo3:
      "L'app può essere scaricata sul mercato Android/iOS; se già scaricata, premere brevemente",
    activeStepInfo5: "per passare al passo successivo",
    activeStepInfo6:
      "Seguire le istruzioni dell'app per cercare il veicolo, trovare il veicolo corrispondente e inserire il codice PIN a 4 cifre visualizzato sul cruscotto del veicolo per completare l'attivazione.",
    activeStepInfo7:
      "Dopo la corretta attivazione, sarai reindirizzato alla pagina di successo (si prega di notare che è necessario completare questa operazione entro 5 minuti, altrimenti il processo di attivazione verrà riavviato.)",
    instrumentDescription: "Spiegazione generale del cruscotto",
    instrumentStopPic: "Schema del cruscotto (stato parcheggiato) ",
    instrumentWorkPic: "Illustrazione del cruscotto (stato di guida)",
    cardPic: "Illustrazione della scheda aggregata",
    instrumentInfo1:
      "Area delle carte intelligenti (compresi schede aggregate, statistiche di guida, musica Bluetooth, impostazioni Bluetooth, salute del veicolo, impostazioni del veicolo)",
    instrumentInfo2:
      "Area delle informazioni centrali (compreso stato di salute del veicolo, statistiche di guida del veicolo)",
    instrumentInfo3:
      "Area informazioni veicolo (inclusa la posizione della modalità, le informazioni sulla portata, lo stato di attivazione della funzione)",
    aggregatedCardArea: "Area delle carte intelligenti - Carte aggregate",
    aggregatedCardInfo1:
      "Mostra lo stato di riproduzione della musica Bluetooth, lo stato della funzione musicale può essere giudicato in base al testo del prompt nella funzione musicale",
    aggregatedCardInfo2:
      "Mostra lo stato di connessione del Bluetooth, quando non connesso, il colore dell'icona è grigio, quando connesso con successo, il colore dell'icona è colorato",
    aggregatedCardInfo3:
      "Mostra lo stato di accensione e spegnimento del registratore di guida, quando non acceso, il colore dell'icona è grigio, quando acceso, il colore dell'icona è colorato",
    aggregatedCardInfo4:
      "La funzione non è ancora disponibile, restate sintonizzati",
    cyclingStatistics: "Area delle carte intelligenti - Statistiche di guida",
    cyclingPic: "Illustrazione delle statistiche del ciclismo",
    cyclingStatisticsInfo1:
      "Qui viene mostrato il chilometraggio totale del veicolo dal momento in cui ha lasciato la fabbrica",
    cyclingStatisticsInfo2:
      "Qui viene mostrato il chilometraggio di un viaggio specifico, è possibile premere brevemente",
    cyclingStatisticsInfo3: "per reimpostare questi dati",
    BluetoothMusic: "Area delle carte intelligenti - Musica Bluetooth",
    BluetoothPic: "Illustrazione della musica Bluetooth",
    BluetoothMusicInfo1:
      "Quando c'è audio, qui vengono visualizzati il nome del cantante e il testo. Quando non c'è audio, qui viene visualizzato 'Brano sconosciuto' (è richiesta la connessione Bluetooth e la riproduzione audio tramite dispositivo mobile)",
    BluetoothMusicInfo2: "Premere brevemente",
    BluetoothMusicInfo3: "per controllare la riproduzione/pausa della musica",
    BluetoothMusicInfo4: "Tenere premuto",
    BluetoothMusicInfo5: "per passare alla canzone successiva",
    vehicleHealth: "Area delle carte intelligenti - Salute del veicolo",
    healthPic: "Illustrazione della salute del veicolo",
    warningPic: "Illustrazione dell'anomalia del veicolo",
    vehicleHealthInfo1:
      "Dopo aver avviato il veicolo, passare a questa carta e rileverà automaticamente lo stato di salute del veicolo",
    vehicleHealthInfo2:
      "Quando si verifica un problema con lo stato di salute del veicolo, la carta visualizza le informazioni di errore corrispondenti e i dettagli dell'errore possono essere visualizzati premendo brevemente il pulsante",
    vehicleHealthInfo3: "",
    vehicleSetting: "Area delle carte intelligenti - Impostazioni del veicolo",
    settingPic: "Schema delle impostazioni del veicolo",
    vehicleSettingInfo1:
      "Questa funzione consente di impostare il veicolo (le impostazioni includono: volume Bluetooth, suono della moto, modalità di visualizzazione, versione del veicolo, impostazioni della lingua, registratore di guida, ripristino delle impostazioni di fabbrica, assistenza alla sicurezza, modalità di associazione in sospeso, unità di distanza, unità di tempo)",
    vehicleSettingInfo2:
      "Per passare da una funzione all'altra, è possibile premere brevemente",
    vehicleSettingInfo3: "per controllare",
    vehicleSettingInfo4:
      "Quando si trova la funzione desiderata e si desidera confermare, è possibile premere brevemente",
    vehicleSettingInfo5: "per confermare",
    instrumentWorkingInfo1:
      "Area delle carte intelligenti (comprensiva di carte aggregate, statistiche del ciclismo, musica Bluetooth)",
    instrumentWorkingInfo2:
      "Area delle informazioni centrali (inclusi velocità in tempo reale, informazioni sulla batteria)",
    instrumentWorkingInfo3:
      "Area informazioni veicolo (inclusa la posizione della modalità, le informazioni sulla portata, la corrente in tempo reale, il consumo di energia in tempo reale)",
    aggregatedCardWorkingInfo2: "Visualizza i dati di ciclismo attuali",
    startCycling: "Iniziare a guidare",
    startInfo:
      "Premere brevemente il pulsante 'Ready' per entrare o uscire dalla modalità ciclismo, il cruscotto visualizza la schermata corrispondente (vedi dettagli sotto)",
    gearShift: "Cambio di modalità",
    gearNote:
      "Nota: Il veicolo ha un totale di cinque modalità, ovvero 【ECO】【COMFORT】【SPORT】【TURBO】【MAM】",
    H1GearNote:
      "Nota: il veicolo ha quattro modalità in totale, ovvero 【ECO】, 【COMFORT】, 【SPORT】 e 【MAM】.",
    gearInfo1:
      "La modalità ECO è adatta per la guida a risparmio energetico e può fornire la maggiore autonomia",
    gearInfo2:
      "La modalità COMFORT è adatta per la guida quotidiana e bilancia l'autonomia, l'accelerazione e la velocità massima.",
    gearInfo3:
      "La modalità SPORT è adatta per la guida sportiva e mette in evidenza le prestazioni di sorpasso e di velocità massima.",
    gearInfo4:
      "La modalità TURBO è adatta per la guida intensa e libera tutte le potenzialità del veicolo.",
    gearInfo5: "La modalità MAM è adatta per spingere/muovere il veicolo.",
    gearInfo6: "Cambia modalità spostando il tasto M a sinistra o a destra",
    gearInfo7: "Premi il tasto TURBO per entrare nella modalità TURBO.",
    gearInfo8:
      "Premi e tieni premuto questo pulsante per entrare in modalità MAM e quindi gira la manopola o cambia M- / M+ per controllare il movimento del veicolo (M- per la retromarcia; M+ per la marcia avanti)",
    gearInfo9: "Premi il tasto M per cambiare modalità",
    gearInfo10:
      "Premere e tenere premuto questo pulsante per accedere alla modalità MAM, quindi è possibile utilizzare M-/M+ per controllare il movimento del veicolo (M- per retromarcia; M+ per avanzare).",
    drivingPage: "Pagina di guida",
    parkingPage: "Pagina di parcheggio",
    gearPic: "Diagramma dell'area di visualizzazione informazioni modalità",
    questions,
    troubles
  }
};

export default it;



// WEBPACK FOOTER //
// ./src/i18n/langs/it.js